// ON PAGE LOAD, SETS THE RENDERED VARIANT QUICK ADD BUTTON WITH THE RESPECTIVE SWATCH
document.addEventListener('DOMContentLoaded', function(){
    const collectionItems = document.querySelectorAll("#product-grid .grid__item");
    if (collectionItems.length != 0){
        collectionItems.forEach(eachItem => {
            const variantId = eachItem.dataset.variantId;
            const currentSwatch = eachItem.querySelector(`a[data-variant-id='${variantId}']`);
            // currentSwatch?.click()
        })
    }
})